import { useState } from 'react';

// icons
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LogoutIcon from '@mui/icons-material/Logout';
import Avatar, { AvatarProps } from '@mui/material/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';

import useAuthContext from 'hooks/useAuthContext';

const AccountMenuButton = styled(ListItemButton)(({ theme }) => ({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: 'auto',
  borderRadius: 8,
  [theme.breakpoints.up('lg')]: {
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },

  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
}));

interface AccountMenuProps {
  avatarImg?: string;
  avatarColor?: string;
  name?: string;
  email?: string;
}

export function AccountMenu({ avatarImg, avatarColor, name, email }: AccountMenuProps) {
  const { logout } = useAuthContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  //   const theme = useTheme();
  //   const { themeToggler } = theme;

  // get the first two initials of the user's name
  const initials = name
    ?.split(' ')
    .map((s) => s[0])
    .slice(0, 2)
    .join('');

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const avatarProps: AvatarProps = {
    alt: name,
    src: avatarImg,
    sx: {
      bgcolor: avatarColor,
    },
    children: initials,
  };

  return (
    <>
      <AccountMenuButton dense onClick={handleClick}>
        <ListItemAvatar sx={{ display: { xs: 'none', lg: 'flex' } }}>
          <Avatar {...avatarProps} />
        </ListItemAvatar>
        <ListItemText sx={{ display: { xs: 'none', lg: 'block' } }} primary={name} secondary={email} />

        <Avatar {...avatarProps} sx={{ display: { xs: 'inline-flex', lg: 'none' }, ...avatarProps?.sx }} />

        <ExpandMoreIcon
          sx={{
            ml: { xs: 0, lg: 1 },
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease',
          }}
        />
      </AccountMenuButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        sx={{ mt: 1 }}
      >
        {/* <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <PersonAddIcon fontSize="small" />
          </ListItemIcon>
          Add another account
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem>
        <MenuItem onClick={themeToggler}>
          <ListItemIcon>
            <LightModeIcon fontSize="small" />
          </ListItemIcon>
          Dark Mode
        </MenuItem>

        <Divider /> */}

        <MenuItem onClick={logout} sx={{ color: 'error.main' }}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" sx={{ color: 'error.main' }} />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}

export default AccountMenu;
